export * from './baSidebar.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baSidebar/index.ts